import { useState } from 'react';

import { getListPayload } from 'coreOld/utils';
import { useGetUoms } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';

import { columns } from './columns';
import UomsListView from './UomsListView';

interface IProps {
  part?: Partial<ICompanyPart>;
  setSelectedItem?;
}

const getPayload = (part: Partial<ICompanyPart>) => {
  return getListPayload({ part: part?.part, manufacturerId: part?.manufacturerId });
};

const UomsList = ({ part, setSelectedItem }: IProps) => {
  const [requestPayload] = useState(getPayload(part));

  const { records, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } =
    useGetUoms(requestPayload);

  const onRowClick = (row) => setSelectedItem(row);

  return (
    <UomsListView
      tableColumns={columns}
      uoms={records}
      onRowClick={onRowClick}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};

export default UomsList;
